module.exports = __webpack_public_path__ + "img/feedback3-3.813f4511.jpg";